document.addEventListener("DOMContentLoaded", function () {
  function findProductCard(button) {
    return (
      button.closest("product-card") ||
      button.closest(".product-card") ||
      button.closest(".product-item") ||
      button.closest(".card-product") ||
      button.closest(".product-card-item") ||
      button.parentElement
    );
  }

  function findProductImage(card) {
    if (!card) return null;

    return (
      card.querySelector(".product-image img") ||
      card.querySelector(".product-card-image img") ||
      card.querySelector(".product-media img") ||
      card.querySelector("picture img") ||
      card.querySelector("img")
    );
  }

  function findCartIcon() {
    return (
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href*="/cart"]') ||
      document.querySelector(".header-cart") ||
      document.querySelector(".cart-icon") ||
      document.querySelector("[data-cart-icon]") ||
      document.querySelector("cart-icon")
    );
  }

  function animateProductToCart(button) {
    const card = findProductCard(button);
    const image = findProductImage(card);
    const cart = findCartIcon();

    if (!image || !cart) return;

    const imageRect = image.getBoundingClientRect();
    const cartRect = cart.getBoundingClientRect();

    if (
      imageRect.width === 0 ||
      imageRect.height === 0 ||
      cartRect.width === 0 ||
      cartRect.height === 0
    ) {
      return;
    }

    const flyingImage = image.cloneNode(true);

    flyingImage.classList.add("levista-flying-product");

    Object.assign(flyingImage.style, {
      left: `${imageRect.left}px`,
      top: `${imageRect.top}px`,
      width: `${imageRect.width}px`,
      height: `${imageRect.height}px`,
      opacity: "1",
      transform: "rotate(0deg) scale(1)"
    });

    document.body.appendChild(flyingImage);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        const targetSize = 24;

        flyingImage.style.left = `${
          cartRect.left + cartRect.width / 2 - targetSize / 2
        }px`;

        flyingImage.style.top = `${
          cartRect.top + cartRect.height / 2 - targetSize / 2
        }px`;

        flyingImage.style.width = `${targetSize}px`;
        flyingImage.style.height = `${targetSize}px`;
        flyingImage.style.opacity = "0.15";
        flyingImage.style.transform = "rotate(25deg) scale(0.3)";
      });
    });

    window.setTimeout(function () {
      flyingImage.remove();

      cart.classList.remove("levista-cart-bounce");

      void cart.offsetWidth;

      cart.classList.add("levista-cart-bounce");

      window.setTimeout(function () {
        cart.classList.remove("levista-cart-bounce");
      }, 550);
    }, 850);
  }

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".btn__quick-shop");

    if (!button || button.disabled) return;

    animateProductToCart(button);
  });
});
/* LEVISTA – KEEP QUICK ADD VISIBLE ON DESKTOP */

function levistaShowDesktopQuickAdd() {
  if (window.innerWidth < 1025) return;

  document.querySelectorAll("button.btn__quick-shop").forEach(function (button) {
    button.classList.remove("invisible-1025");

    button.style.setProperty("display", "flex", "important");
    button.style.setProperty("opacity", "1", "important");
    button.style.setProperty("visibility", "visible", "important");
    button.style.setProperty("pointer-events", "auto", "important");

    const text = button.querySelector(".product-addtocart-btn");

    if (text) {
      text.classList.remove("hidden-on-load", "d-none");

      text.style.setProperty("display", "inline-flex", "important");
      text.style.setProperty("opacity", "1", "important");
      text.style.setProperty("visibility", "visible", "important");
      text.style.setProperty("color", "#ffffff", "important");
      text.style.setProperty("align-items", "center", "important");
      text.style.setProperty("justify-content", "center", "important");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  levistaShowDesktopQuickAdd();

  setTimeout(levistaShowDesktopQuickAdd, 300);
  setTimeout(levistaShowDesktopQuickAdd, 1000);
  setTimeout(levistaShowDesktopQuickAdd, 2000);
});

window.addEventListener("load", levistaShowDesktopQuickAdd);
window.addEventListener("resize", levistaShowDesktopQuickAdd);

const levistaQuickAddObserver = new MutationObserver(function () {
  levistaShowDesktopQuickAdd();
});

levistaQuickAddObserver.observe(document.body, {
  childList: true,
  subtree: true
});